module.exports = __webpack_public_path__ + "static/media/rewardsDialogCross.bc4d840c.svg";